import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BenefitDetailsComponent } from './components/benefit-details/benefit-details.component';
import { BenefitsComponent } from './components/benefits/benefits.component';
import { ConversorComponent } from './components/conversor/conversor.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { LoginComponent } from './components/login/login.component';
import { PointsHistoricComponent } from './components/points-historic/points-historic.component';
import { SorteosComponent } from './components/sorteos/sorteos.component';
import { RegisterComponent } from './components/register/register.component';
import { ShellAppComponent } from './components/shell-app/shell-app.component';
import { ShellProgramComponent } from './components/shell-program/shell-program.component';
import { SorteosHistoricComponent } from './components/sorteos-historic/sorteos-historic.component'
import { UserComponent } from './components/user/user.component';
import { AuthGuard } from './guards/auth/auth.guard';
import { PagenotfoundComponent } from './components/pagenotfound/pagenotfound.component';
import { TransferComponent } from './components/transfer-points/transferPoints.component';
import { QuestionsComponent } from './components/questions/questions.component';
import { ConversorGuard } from './guards/conversor/conversor.guard';
import { FestivitiesOpportunitiesComponent } from './components/festivities-opportunities/festivities-opportunities.component';
import { PromoGamerComponent } from './components/promo-gamer/promo-gamer.component';

const routes: Routes = [
  { path: '' , component: DashboardComponent, pathMatch: 'full'},
  { path: 'dashboard' , component: DashboardComponent},
  { path: 'cambiar-password' , component: DashboardComponent},
  { path: 'validar-marketplace' , component: DashboardComponent},
  { path: 'ingresar' , component: DashboardComponent},
  { path: 'login' , component: LoginComponent},
  { path: 'login-app' , component: LoginComponent},
  { path: 'login-web' , component: LoginComponent},
  { path: 'registro' , component: RegisterComponent},
  { path: 'conversor' , component: ConversorComponent,canActivate:[ConversorGuard]},
  { path: 'transferencia-puntos', component: TransferComponent, canActivate:[AuthGuard]},
  { path: 'perfil', component: UserComponent, canActivate:[AuthGuard]},
  { path: 'beneficios-y-descuentos', component: BenefitsComponent},
  { path: 'beneficios-y-descuentos/:category', component: BenefitsComponent},
  { path: 'benefits/:id', component: BenefitsComponent },
  { path: 'benefit-details/:id', component: BenefitDetailsComponent },
  { path: 'beneficios-y-descuentos/:category/:name', component: BenefitDetailsComponent },
  { path: 'app', component: ShellAppComponent },
  { path: 'programa', component: ShellProgramComponent},
  { path: 'historial-sorteos', component: SorteosHistoricComponent, canActivate:[AuthGuard]},
  { path: 'historial', component: PointsHistoricComponent, canActivate:[AuthGuard]},
  { path: 'sorteos/:code', component: SorteosComponent },
  { path: 'preguntas-frecuentes', component: QuestionsComponent },
  { path: 'festividades', component: FestivitiesOpportunitiesComponent },
  { path: 'festividades/:category', component: FestivitiesOpportunitiesComponent},
  { path: 'promo-gamer/:name', component: PromoGamerComponent},
  { path: 'shell-box', redirectTo: 'app', pathMatch: 'full' },
  { path: 'beneficios', redirectTo: '/beneficios-y-descuentos', pathMatch: 'full' },

  { path: '**', pathMatch: 'full', component: PagenotfoundComponent },

];
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {

 }
